require('./bootstrap');

//import 'laravel-datatables-vite';

/** Since 2.0.1, support toastify container */
window.toasify = require('toastify-js');